import { render } from "./CategoryProducts.vue?vue&type=template&id=4ccd0f67"
import script from "./CategoryProducts.vue?vue&type=script&lang=js"
export * from "./CategoryProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ZyMall/components/products/CategoryProducts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ccd0f67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ccd0f67', __exports__)) {
    api.reload('4ccd0f67', __exports__)
  }
  
  module.hot.accept("./CategoryProducts.vue?vue&type=template&id=4ccd0f67", () => {
    api.rerender('4ccd0f67', render)
  })

}


export default __exports__